import { render, staticRenderFns } from "./Tab-Coupon.vue?vue&type=template&id=8df36de2"
import script from "./Tab-Coupon.vue?vue&type=script&lang=js"
export * from "./Tab-Coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports